export type AnchorProps = {
   url: string,
   text?: string,
   copytext?: boolean
}

const Anchor: React.FC<AnchorProps> = ({ url, text, copytext }) => (
   <a
      target="_blank"
      href={url}
      rel="noreferrer"
      className="underline text-blue-600 hover:text-blue-900 visited:text-purple-600 px-1">
      {
         copytext
            ? url
            : text
      }
   </a>
)

export default Anchor;